import { ReactNode, createContext, useState } from 'react'

export type CopilotDropdownContextProps = {
    isDropdownOpen: boolean
    closeDropdown: () => void
    openDropdown: () => void
}

export const CopilotDropdownContext = createContext({} as CopilotDropdownContextProps)

const CopilotDropdownContextManager = ({ children }: { children: ReactNode }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false)

    function closeDropdown() {
        setIsDropdownOpen(false)
    }

    function openDropdown() {
        setIsDropdownOpen(true)
    }

    return (
        <CopilotDropdownContext.Provider
            value={{
                isDropdownOpen,
                closeDropdown,
                openDropdown,
            }}
        >
            {children}
        </CopilotDropdownContext.Provider>
    )
}

export default CopilotDropdownContextManager
